export class GetUserPortalActiveDiscount {
  static readonly type = '[Discount] GetUserPortalActiveDiscount';
}
